<template>
<div id="app">
   
  <router-view />

</div>

</template>

<script>
//import ButtonOne from './components/ButtonOne.vue';
//import GetRequestData from './components/GetRequestData.vue';
//import MetadataButton from './components/MetadataButton.vue';

//import frontPage from './components/frontPage.vue';
//import settingsPage from './components/settingsPage.vue';
//import LandingPage from './components/LandingPage.vue';

//import UniSwap from './components/UniSwap.vue';

//import VerificationPage from './components/VerificationPage.vue';

//import TransactionEx from './components/TransactionEx.vue';


//import MenuButton from './components/MenuButton.vue';

//import multiSigEx from './components/multiSigEx.vue';

//import GetRequestAddress from './components/GetRequestAddress.vue';
//import RouterComp from './components/RouterComp.vue';




export default {
  name: 'App',
  components: {
   //ButtonOne,
   //GetRequestData,
    //MetadataButton,
   //LandingPage,
   //frontPage,
   //settingsPage,
 
   //TransactionEx,

   //MenuButton,
  
  // multiSigEx,

  
  // VerificationPage,
    
    //GetRequestAddress,
    //RouterComp,
    
  }
}
</script>

<style>
#app {
  font-family: 'Courier New', Courier, monospace;
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  font-size: 20px;
  background-color: #cbd0d7;
  position: absolute;
  top: 0;
  left: 0;
}


</style>
<!-- 

<template>
  <input type="text" v-model="selectedAddress" />
  <button @click="getFilteredUsers">Filter using selected address</button>
  <div>
   <p
      v-for="user in users"
     :key="user.id"
   >
   {{ user.name }}
  </p>
  </div>
 </template>
 <script>
 export default {
  data: () => ({
   selectedAddress: null,
   users: [],
  }),
 
  methods: {
   async getFilteredUsers() {
    const filteredUsers = await fetch(`https://api.sampleapis.com/beers/${this.selectedAddress}`);
    this.users = await filteredUsers.json();
   },
  },
 };
 </script>




  <GetRequestAddress/>
  <button-one/>
  <metadata-button/>
  <GetRequestData/>
  
  <RouterComp/>
-->

